module.exports = __webpack_public_path__ + "img/homelisticon4.30e9fa58.png";